import { createAction } from 'redux-actions';
import * as types from './types';

export const init = createAction(types.INIT);
export const setForm = createAction(types.SET_FORM);
export const setStep = createAction(types.SET_STEP);
export const setComplete = createAction(types.SET_COMPLETE);
export const resetSteps = createAction(types.RESET_STEPS);
